/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.Vue = require('vue');

import VueRouter from 'vue-router'
import VueCarousel from 'vue-carousel'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Navbar from './components/Navbar.vue';
import Footnote from './components/Footnote.vue';
import AOS from 'aos'
import Appointment from './pages/Appointment.vue';
import Whitepaper from './pages/Whitepaper.vue';
import Ipadimage from './components/Ipadimage.vue';
import Impressum from './pages/Impressum.vue';
import Dataprivacy from './pages/DataPrivacy.vue';
import Agb from './pages/Agb.vue';
import Teilnahmebedingungen from './pages/Teilnahmebedingungen.vue';
import VueKinesis from 'vue-kinesis'
import Newsletter from './pages/Newsletter.vue';

import 'aos/dist/aos.css'

AOS.init({
    disable: 'mobile',
    once: false
});

Vue.use(VueRouter)
Vue.use(VueCarousel)
Vue.use(VueReCaptcha, { siteKey: '6LfaA8AZAAAAAKjZvcAORhVfqAOb4z2ludbRA7q7' })
Vue.use(VueKinesis)
const router = new VueRouter({
    mode: 'history',
    root: '/',
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                offset: {
                    x: 0,
                    y: 58
                }
            }
        } else if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes: [{
            path: '/',
            name: 'home',
            component: require('./pages/Home.vue').default
        },
        {
            path: '/appointment',
            name: 'appointment',
            component: require('./pages/Appointment.vue').default
        },
        {
            path: '/whitepaper',
            name: 'whitepaper',
            component: require('./pages/Whitepaper.vue').default
        },
        {
            path: '/imprint',
            name: 'impressum',
            component: require('./pages/Impressum.vue').default
        },
        {
            path: '/dataprivacy',
            name: 'datenschutz',
            component: require('./pages/DataPrivacy.vue').default
        },
        {
            path: '/terms',
            name: 'agb',
            component: require('./pages/Agb.vue').default
        },
        {
            path: '/participation',
            name: 'teilnahmebedingungen',
            component: require('./pages/Teilnahmebedingungen.vue').default
        },
        {
            path: '/newsletter',
            name: 'newsletter',
            component: require('./pages/Newsletter.vue').default
        }
    ]
})

let app = new Vue({
    components: {
        Navbar,
        Footnote,
        Appointment,
        Whitepaper,Impressum,Dataprivacy,Agb,Teilnahmebedingungen,Ipadimage,Newsletter
    },
    router: router
}).$mount('#app');

